// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"f5da5533","84":"8814a3ae","217":"93918eaa","336":"b1369695","388":"85efa252","522":"2a37c611","598":"d7f14fb5","609":"204fdbdd","732":"c4ee1ee1","880":"62fca567"}[chunkId] + ".chunk.js";
};